
import { css } from 'styled-components'; 
    

const colorNormal = {
  primaryColor:"#f14773",
  secondaryColor:"#73c8e9",
  mainWhite:"#fff",
  mainBlack:"#222",
  mainGrey:"#545554",
  lightGrey:"#939493",
  featured: "#f14773"

}

// const colorChristmas = {
//   primaryColor:"#BB2528", // Firebrick
//   secondaryColor:"#146B3A", // Dark Spring GreenGreen
//   mainWhite:"#FAFDFD", 
//   mainBlack:"#165B33", // Cal Ply Pommona Green
//   mainGrey:"#9D7E59", // Arylide Yellow
//   lightGrey:"#D9D2CA", // Very Pale Yellow
//   featured: "#EEDA67"
// }

export const setColor = colorNormal;




export const setFont = {
    main:"'Montserrat', sans-serif",
    slanted:"'Montserrat', cursive;"
}

export const setFlex = ({ x="center", y="center"}={}) => {
    return `display:flex;align-items:${y};justify-content:${x}`
}

export const setBackground = ( {img="https://images.pexels.com/photos/944463/pexels-photo-944463.jpeg?cs=srgb&dl=bay-beach-blue-944463.jpg&fm=jpg",
 color="rgba(0,0,0,0)", fixed="fixed"}={}) => {
    return `
    background: linear-gradient(${color},${color}),
    url(${img})center/cover ${fixed} no-repeat;
    `
}

export const setRem = (number = 16)=>{
    return `${number/16}rem`
}

export const setLetterSpacing = (number =2) => {
    return `letter-spacing:${number}px`
}

export const setShadow = {
  light:'box-shadow: 3px 3px 5px 0px rgba(0,0,0,0.75);',
  dark:'box-shadow: 6px 6px 5px 0px rgba(0,0,0,0.75);',
  darkest:'box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);'
}

export const setBorder = ({
    width="2px",
    style="solid",
    color="black"
}={}) => {
    return `border: ${width} ${style} ${color}`
}

const sizes = {
    large: 1200,
    desktop: 992,
    tablet: 768,
    phone: 576
  };
  
  // Iterate through the sizes and create a media template
  export const media = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
      @media (min-width: ${sizes[label] / 16}em) {
        ${css(...args)}
      }
    `;
  
    return acc;
  }, {});
  
  export const setTransition = ({
      property = "all",
      time = "0.3s",
      timing="ease-in-out"
    } = {}) => {
      return `transition:${property} ${time} ${timing}`;
  };